<!--
 * @Author: wh
 * @Date: 2020-07-27 10:49:11
 * @LastEditTime: 2020-07-29 21:32:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\customerTerminal\feedback\newFeedback.vue
-->
<template>
    <div class="newFeedback">
        <van-nav-bar
            title="意见反馈"
            left-text=""
            left-arrow
            right-text="保存"
            @click-left="onClickLeft"
            @click-right="save"
        >
        </van-nav-bar>
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @confirm="confirmMonth"
                @cancel="showCalendar=false"
            ></van-datetime-picker>
        </van-popup>
        <section>
            <van-form>
                <van-field
                    label="合同编号"
                    :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                    input-align="right"
                    placeholder="请选择合同"
                    right-icon="arrow"
                    v-model="formData.contract_number"
                    readonly
                    @click="choseContract"
                ></van-field>
                <van-cell
                    title="客户名称"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                    :value="formData.client_name"
                ></van-cell>
                <van-cell
                    title="工程名称"
                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                    :value="formData.engineering_name"
                ></van-cell>
                <van-cell
                    title="签订日期"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    :value="formData.signing_date"
                ></van-cell>
                <van-cell
                    title="供料时间"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    :value="formData.supply_first_time"
                ></van-cell>
                <van-cell
                    title="已供方量"
                    :icon="require('@/assets/images/icons/icon_6.png')"
                    :value="formData.supply_volume"
                ></van-cell>
                <van-field
                    label="问题/建议"
                    :left-icon="require('@/assets/images/icons/icon_34.png')"
                    readonly
                ></van-field>
                <van-field
                    rows="4"
                    autosize
                    type="textarea"
                    class="iconfont iconbeizhu textarea"
                    placeholder="问题/建议"
                    v-model="formData.describe"
                ></van-field>
                <van-field
                    label="时间"
                    :left-icon="require('@/assets/images/icons/icon_6.png')"
                    input-align="right"
                    placeholder="请选择"
                    right-icon="arrow"
                    v-model="formData.Created"
                    readonly
                    @click="showCalendar=true"
                ></van-field>
                <van-field
                    label="联系人"
                    :left-icon="require('@/assets/images/icons/icon_3.png')"
                    input-align="right"
                    placeholder="请输入"
                    v-model="formData.contacts"
                ></van-field>
                <!-- <van-field
                    label="企业反馈"
                    :left-icon="require('@/assets/images/icons/icon_gy_4.png')"
                    readonly
                ></van-field>
                <van-field
                    rows="2"
                    autosize
                    type="textarea"
                    maxlength="80"
                    class="iconfont iconbeizhu textarea"
                    placeholder="企业反馈"
                    v-model="formData.Reply"
                    readonly
                ></van-field>
                <van-field
                    label="反馈日期"
                    :left-icon="require('@/assets/images/icons/icon_6.png')"
                    input-align="right"
                    placeholder="请选择"
                    right-icon="arrow"
                    v-model="formData.ReplyTime"
                    readonly
                ></van-field> -->
            </van-form>
        </section>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    components: {},
    props: {},
    data() {
        return {
            formData: {},
            showCalendar: false,
            currentDate: new Date(),
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        if (this.$route.params.type) {
            if (this.$route.params.type === 'selectedProjectCallBack') {
                this.selectedProjectCallBack();
            } else if (this.$route.params.type === 'new') {
                this.formData.Created = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
                this.formData.contacts = this.$takeTokenParameters('Name');
            }
        }
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 选择合同
        choseContract() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'selectContract', params: { formData: this.formData } });
        },
        // 合同选择完成
        async selectedProjectCallBack() {
            if (this.$route.params.formData) {
                this.formData = this.$route.params.formData;
            }
            const res = await this.getSupplyVolumeApi();
            if (res) {
                this.formData.supply_volume = res.volume;
                this.formData.supply_first_time = res.supply_time_first;
                this.$forceUpdate();
            }
        },
        // 保存
        async save() {
            const res = await this.addFeedbackApi();
            if (res) {
                this.$toast('保存成功');
                this.$router.isBack = 1;
                this.$router.go(-1);
            }
        },
        // 时间选择完成
        confirmMonth(value) {
            this.formData.Created = this.formatDate(value);
            this.showCalendar = false;
        },
        // 返回的时间格式化
        formatDate(date) {
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            let Hours = date.getHours();
            if (Hours < 10) {
                Hours = '0' + Hours;
            }
            let Minutes = date.getMinutes();
            if (Minutes < 10) {
                Minutes = '0' + Minutes;
            }
            let Seconds = date.getSeconds();
            if (Seconds < 10) {
                Seconds = '0' + Seconds;
            }
            return `${date.getFullYear()}-${month}-${day} ${Hours}:${Minutes}:${Seconds}`;
        },
        getSupplyVolumeApi() {
            return this.$axios.$get('/interfaceApi/production/productorder/get_supply_volume/' + this.formData.contract_number, { defEx: true });
        },
        addFeedbackApi() {
            return this.$axios.$post('/interfaceApi/sale/feedback/add', this.formData, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.newFeedback
    height 100%
    section
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        padding-bottom 20rpx
        .van-cell:not(:last-child)::after
            left 0
        .van-cell
            font-size 15rpx
        .iconbeizhu:before
            margin-right 5rpx
        .textarea
            border 1px solid #ebedf0
            margin 10rpx
            width calc(100% - 20rpx)
            border-radius 5rpx
        .van-cell__value
            color #323233
</style>